import Controller from './Controller'
import type { Editor } from '../Editor'
import type { ContentService, Document } from '@fast-editor/core'
import { FragmentImage } from '@fast-editor/core'

export default class ContentController extends Controller {
  private service: ContentService
  constructor(editor: Editor, doc: Document, service: ContentService) {
    super(editor, doc)
    this.service = service
  }

  public insertImage(url: string, width: number, height: number) {
    const imageFrag = new FragmentImage()
    imageFrag.setAttributes({
      width,
      height,
      src: url,
      oriWidth: width,
      oriHeight: height,
    })
    this.service.insertFragment(imageFrag)
  }
}
